import { brandColors } from './brandColors';

/** CSS variable references — ThemeContext sets --brand-* from tenant Settings. */
export const brandCss = {
  primary: `var(--brand-primary, ${brandColors.primary})`,
  primaryDark: `var(--brand-primary-dark, ${brandColors.primaryDark})`,
  primaryLight: `var(--brand-primary-light, ${brandColors.primaryLight})`,
  accent: `var(--brand-accent, ${brandColors.accent})`,
  green50: `var(--brand-green50, ${brandColors.green50})`,
  green100: `var(--brand-green100, ${brandColors.green100})`,
  green200: `var(--brand-green200, ${brandColors.green200})`,
  gradientPrimary: `var(--brand-gradient-primary, ${brandColors.gradientPrimary})`,
  gradientPrimaryHover: `var(--brand-gradient-primary-hover, linear-gradient(135deg, ${brandColors.primaryDark} 0%, #3d0f99 100%))`,
  gradientSoft: `var(--brand-gradient-soft, ${brandColors.gradientSoft})`,
  gradientAuth: `var(--brand-gradient-auth, ${brandColors.gradientAuth})`,
  focusRing: 'var(--brand-focus-ring, 0 0 0 3px rgba(98,33,214,0.2))',
  focusRingStrong: 'var(--brand-focus-ring-strong, 0 0 0 3px rgba(98,33,214,0.32))',
  shadowMd: `var(--brand-shadow-md, ${brandColors.shadowMd})`,
  shadowLg: `var(--brand-shadow-lg, ${brandColors.shadowLg})`,
  shadowButton: 'var(--brand-shadow-button, 0 4px 14px rgba(98,33,214,0.4))',
  shadowButtonLg: 'var(--brand-shadow-button-lg, 0 6px 20px rgba(98,33,214,0.45))',
  shadowIcon: 'var(--brand-shadow-icon, 0 8px 24px rgba(98,33,214,0.35))',
  sidebar: `var(--brand-sidebar, ${brandColors.sidebar})`,
  tableHeader: 'var(--brand-table-header, var(--brand-primary))',
  tableHeaderText: 'var(--brand-table-header-text, #ffffff)',
  formHeader: 'var(--brand-form-header, var(--brand-primary))',
  formHeaderText: 'var(--brand-form-header-text, #ffffff)',
  formHeaderGradient: 'var(--brand-form-header-gradient, var(--brand-gradient-primary))',
};

/** Active / success status chips tied to tenant brand */
export const activeStatusColors = {
  bg: brandCss.green100,
  color: brandCss.primaryDark,
};
